import React from 'react';

const CategoryPage = () => (
  <div className="categoryP">
    <h1>Under construction</h1>
  </div>
);

export default CategoryPage;
